var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditFilled = function SvgEditFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M18.242 5.759a1.09 1.09 0 0 0-1.541 0L6.34 16.117l-.616 2.157 2.157-.616 10.36-10.36a1.09 1.09 0 0 0 0-1.54m-2.56-1.018a2.53 2.53 0 0 1 3.577 3.576L8.636 18.94l-3.595 1.028a.816.816 0 0 1-1.009-1.009l1.028-3.595zM11.419 19.282c0-.396.321-.717.718-.717h7.145a.718.718 0 1 1 0 1.435h-7.145a.72.72 0 0 1-.718-.718",
    clipRule: "evenodd"
  })));
};
export default SvgEditFilled;